export const StProc = ({ value, record }) => record.result?.stproc != null ? ( (!!record.result?.stproc) ? 'Ja' : 'Nein' ) : ''
